/**
 *  Note this file automatically generated from
 *  @link http://gitlab.fimacomarketing.com:10080/ProninE/BGServerGame/tree/master/ServerPHP/daemon/daemon_node/public/minigames/common/MinigameMathCommon.js
 */
'use strict';
import { MinigameConnector } from './MinigameConnector'
import { PlayerConnector } from 'minigame_client/support_connectors/player_connector'

/**
 * MinigameMathCommon class.
 *
 * About classes  https://learn.javascript.ru/class-inheritance
 * @param socket
 * @param {number} game_id
 */

export function MinigameMathCommon(socket, game_id) {
    this.MODEL_LOCAL_LIFE_TIME = 10000; //10 секунд ожидание сервера
    this.MODEL_LOCAL_WARNING_TIME = 3000; //3 секунд прелоадер
    this.ACTION_SET_ACCOUNT = "accountSet";

    this.m_model = {
        is_fake: true,
        local: {
            id: -1,
            is_local: true,
            timestamp:0
        }

    };
    this.m_model_game_counter = 0;
    this.m_model_player_counter = 0;

    this.m_player_info = {
        is_fake: true,
        "name":"player_name",
        "uuid": "",
        "active_account_uuid" : "",
        "account": {
            "uuid": "",
            "currency" : {
                "code_name" : "Cr"
            },
            "value":0,
            "valueWithCurrency": "0 Cr"
        }
    };
    this.m_minigame_connector = this.setupMinigameConnector(socket,game_id);
    this.m_player_connector   = this.setupPlayerConnector(socket);
    this.setupCallbacks();


    var self = this;
    this.m_minigame_connector.socket.on("session_changed", function(data) {
        console.log("session_changed", data);
        self.cb_auth_changed(data);
    });

    this.timeIdReconnect = null;
}

//noinspection JSUnusedLocalSymbols
MinigameMathCommon.prototype.onError = function( err) {
};

MinigameMathCommon.prototype.setVerbose = function(value) {
    this.m_minigame_connector.verbose = value;
    this.m_player_connector.verbose = value;
};
MinigameMathCommon.prototype.setupCallbacks = function() {
    var self = this;
    this.cb_account_changed = function(data) {console.log("cb_account_changed", data)};
    this.cb_model_changed = function(data) {console.log("model changed", data);};
    this.cb_model_outdated = function(data) {console.log("model outdated", data);};
    this.cb_unauthorised = function(data ) {console.log("cb_unauthorised", data);};
    this.cb_account_selection_changed = function(data ) {
        alert("The currency is changed");
        this.doSetGameAccountToPlayerActiveAccount();
    };
    this.cb_auth_changed = function(data) {
        console.log("cb_auth_changed", data);
        setTimeout( () => {
            self.__reconnectSocket();
        }, 1000);
    }
};

MinigameMathCommon.prototype.setTimeoutForModel = function(model_name, callback, timeoutMs) {

    if (this.timeIdReconnect) clearTimeout(this.timeIdReconnect);

    var self = this;
    var id = self[model_name].local.id;
    this.timeIdReconnect = setTimeout( function() {
        var model = self[model_name];
        if(model.local.id == id) {
            callback();
        }
    }, timeoutMs);
};


MinigameMathCommon.prototype.isConnected = function() {
    return this.m_minigame_connector.socket.connected;
};


MinigameMathCommon.prototype.isPreloaderVisible = function() {
    if(!this.m_model.local || !this.m_model.local.is_local)
        return;
    var ts = Date.now();
    return this.m_model.local.timestamp + this.MODEL_LOCAL_WARNING_TIME < ts;
};


MinigameMathCommon.prototype.__reconnectSocket = function() {
    //reconnecting
    var socket = this.m_minigame_connector.socket;
    socket.close();
    socket.open();
};

MinigameMathCommon.prototype.__onModelOutdated = function(model) {
    //reconnecting
    console.log("model outdated ..reconnecting");
    this.__reconnectSocket();
    console.log("reconnecting done");

    var self = this;
    // если реконнект произойдет, но модель не придет из-за ошибки сервера, то и таймер локальной модели не запустится,
    // поэтому запускаем таймер и здесь, получим периодический вызов пока не придет модель
    this.setTimeoutForModel("m_model", function() { self.__onModelOutdated(model);}, model.local.life_time);
    this.cb_model_outdated(model);
};

MinigameMathCommon.prototype.__onGameModelChanged = function(model, is_local = true, model_hash = null) {
    var self = this;
    model = this.__validateModel(model);
    model = this.__modelAddLocal(model,this.m_model_game_counter++, is_local, model_hash);
    this.m_model = model;

    this.__updateGameAccountUuid();

    if(model.local.life_time > 0)
        self.setTimeoutForModel("m_model", function() { self.__onModelOutdated(model);}, model.local.life_time);

    this.cb_model_changed(this.m_model);
};

MinigameMathCommon.prototype.__onPlayerModelChanged = function(model, is_local = true, account_changed = true) {
    var self = this;
    model =  this.__modelAddLocal(model, this.m_model_player_counter++, is_local);
    this.m_player_info = model;

    if(model.local.life_time > 0)
       self.setTimeoutForModel("m_player_info", function() { self.__onModelOutdated(model);}, model.local.life_time);

    //console.log("player_info_changed ", this.m_player_info );
    if(account_changed)
        this.cb_account_changed(this.m_player_info.account);
};


MinigameMathCommon.prototype.__modelAddLocal = function(model,id, is_local, model_hash) {
    model.local = {
        id: id,
        timestamp : Date.now(),
        is_local: is_local,
        life_time: (is_local ? this.MODEL_LOCAL_LIFE_TIME : null),
        model_hash: model_hash
    };
    return model;
};

/**
 * Тут игра может проверить модель и можифицировать ее прежде чем она применится
 * @param model
 * @returns {*}
 * @protected
 */
MinigameMathCommon.prototype.__validateModel = function(model) {
    return model;
};

MinigameMathCommon.prototype.__updateGameAccountUuid = function() {
    if(this.m_model.is_fake || this.m_player_info.is_fake)
        return;

    if(this.m_model.local.is_local)
        return;

    var game_account_uuid = this.__getGameAccountUuid();
    if(!game_account_uuid) { // первая инициализация счета (первый запуск игры)
        this.doSetGameAccountToPlayerActiveAccount();
        return;
    }

    if(!this.m_player_info.account || this.m_player_info.account.uuid != game_account_uuid) {
        this.m_player_info.account = this.__getPlayerAccount(game_account_uuid);
        this.cb_account_changed(this.m_player_info.account);
    }

    if(game_account_uuid != this.m_player_info.active_account_uuid && this.__canChangeGameAccount())
        this.cb_account_selection_changed([]);
};

/////////////////////////////////////////////////////////////////
//// методы необходимые для смены счетов их можно переоределить
////////////////////////////////////////////////////////////////
/**
 * Вызывает смену текущего счета для игры
 * @param account
 * @param cb
 * @protected
 */
MinigameMathCommon.prototype.__doSetGameAccount = function (account, cb) {
    this.m_minigame_connector.doAction(this.ACTION_SET_ACCOUNT, { account: account }, cb);
};

/**
 * Проверка можем ли сменить счет игры
 * @returns {boolean}
 * @protected
 */
MinigameMathCommon.prototype.__canChangeGameAccount = function() {
    return this.isActionAvailable(this.ACTION_SET_ACCOUNT);
};
/**
 * Получить идентификатор текущего счета игры
 * @returns {*}
 * @protected
 */

MinigameMathCommon.prototype.__getGameAccountUuid = function() {
    if(!this.m_model.account)
        return null;
    return this.m_model.account.uuid;
};

/**
 * проверяет доступен ли метод
 * @param action_name
 * @returns {boolean}
 */
MinigameMathCommon.prototype.isActionAvailable = function(action_name) {
    return this.m_model.actions.find( function(el) {return el == action_name;}) !== undefined;
};

////////////////////////////////////////
//////////////////////////////////////////



MinigameMathCommon.prototype.setupMinigameConnector = function(socket, game_id) {

    var self = this;
    var minigame_connector = new MinigameConnector(socket, game_id);
    minigame_connector.proceed_errors = false;

    minigame_connector.socket.on("connect", function() {
        minigame_connector.doModelGet(function (e, result) {
            self.__onGameModelChanged(result.model,false, result.model_hash);
        });
    });

    minigame_connector.setCallbackModelChanged( function(result) {
       self.__onGameModelChanged(result.model,false, result.model_hash);
    });

    return minigame_connector;
};

/**
 * Вызывайте этот метод когда ожидаетс изменение баланса
 * @param delta
 */
MinigameMathCommon.prototype.localBalanceChange = function(delta) {
    if(delta == 0)
        return;

    if(this.m_player_info.account) {
        this.m_player_info.account.value += delta;
        this.__updatePlayerAccount(this.m_player_info.account);
    }
};


MinigameMathCommon.prototype.setupPlayerConnector = function(socket) {
    var self = this;
    var player_connector = new PlayerConnector(socket);
    player_connector.proceed_errors = false;

    player_connector.socket.on("connect", function() {
        player_connector.doViewSelf(["accounts"], function(e,result) {
            self.__onPlayerModelChanged(result, false);
            self.__updateGameAccountUuid();
        });
    });

    player_connector.cb_account_changed_any = function(data) {
        self.__updatePlayerAccount(data.account, false);
    };

    player_connector.cb_account_select = function (data) {
        self.m_player_info.active_account_uuid = data.account.uuid;
        self.__updatePlayerAccount(data.account, false);
        self.__updateGameAccountUuid();
    };

    player_connector.setCallbackOnUnauthorised(  function(data) {
        self.__onUnauthorised(data);
    } );

    return player_connector;
};

MinigameMathCommon.prototype.doSetGameAccountToPlayerActiveAccount = function() {
    var account_uuid = this.m_player_info.active_account_uuid;
    var active_account_uuid = this.__getGameAccountUuid();
    if(active_account_uuid == account_uuid)
        return;

    this.__doSetGameAccount( this.__getPlayerAccount(account_uuid) );
};

MinigameMathCommon.prototype.__getPlayerAccount = function(account_uuid) {
    var index = this.m_player_info.accounts.findIndex(function (account) {
        return (account.uuid == account_uuid);
    } );
    if(index < 0 )
        return null;

    return this.m_player_info.accounts[index];
};


MinigameMathCommon.prototype.__updatePlayerAccount = function(new_account, is_local = true) {
    var account_uuid = new_account.uuid;
    if(this.m_player_info.accounts === undefined)
        return;

    var index = this.m_player_info.accounts.findIndex(function (account) {
        return (account.uuid == account_uuid);
    } );

    if(index >= 0)
        this.m_player_info.accounts[index] = new_account;
    else
        this.m_player_info.accounts.push(new_account);

    var selected_account_changed = false;
    if(this.__getGameAccountUuid() == account_uuid) {
        this.m_player_info.account = new_account;
        selected_account_changed = true;
    }
    this.__onPlayerModelChanged(this.m_player_info, is_local, selected_account_changed);
};


MinigameMathCommon.prototype.__onUnauthorised = function(data) {
    this.cb_unauthorised(data);
};




// WEBPACK FOOTER //
// ./src/library/minigame_client/common/MinigameMathCommon.js